import axios from 'axios';
import { baseUrl } from "../api/env"; //引入baseUrl
// create an axios instance
const service = axios.create({
    baseURL: baseUrl, // api 的 base_url
    timeout: 600000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        config.data = config.data || {};
        
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    response => {
        // if (response.data.code == -1) {
        //     localStorage.clear();
        //     Router.push({ name: 'Login' })
        // }
        // response.data.data = JSON.parse(Decrypt(response.data.data, response.data.key))
        return response.data;
    }, error => {
        console.log(error)
        // if (error.toString().indexOf('Error: timeout') !== -1) {
        //     Toast('加载超时，请检查网络连接');
        //     return Promise.reject(error)
        // } else if (error.toString().indexOf('Error: Network Error') !== -1) {
        //     Toast('网络请求错误');
        //     return Promise.reject(error)
        // } else {
        //     Toast('未知错误，请稍后再试');
        //     return Promise.reject(error)
        // }
        // return Promise.reject(error);
    });

export default service;